var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon, _path15, _polygon2, _path16, _path17, _circle9, _path18, _path19, _path20, _polygon3, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppDevNoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 828.07821,
    height: 484,
    viewBox: "0 0 828.07821 484",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M688.4609,477h-485.5a17.01917,17.01917,0,0,1-17-17V225a17.01917,17.01917,0,0,1,17-17h485.5a17.01917,17.01917,0,0,1,17,17V460A17.01917,17.01917,0,0,1,688.4609,477Zm-485.5-267a15.017,15.017,0,0,0-15,15V460a15.017,15.017,0,0,0,15,15h485.5a15.017,15.017,0,0,0,15-15V225a15.017,15.017,0,0,0-15-15Z",
    transform: "translate(-185.9609 -208)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.25,
    cy: 49.5,
    r: 9,
    fill: "#ccc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.25,
    cy: 83.5,
    r: 9,
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.25,
    cy: 117.5,
    r: 9,
    fill: "#ccc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.25,
    cy: 151.5,
    r: 9,
    fill: "#ccc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.75,
    cy: 219.5,
    r: 9,
    fill: "#ccc"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.75,
    cy: 219.5,
    r: 9,
    fill: "#ccc"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.75,
    cy: 219.5,
    r: 9,
    fill: "#ccc"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.75,
    cy: 219.5,
    r: 9,
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M620.2109,258.5h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z",
    transform: "translate(-185.9609 -208)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M620.2109,292.5h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z",
    transform: "translate(-185.9609 -208)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M620.2109,326.5h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z",
    transform: "translate(-185.9609 -208)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M620.2109,360.5h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z",
    transform: "translate(-185.9609 -208)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M380.2109,394.5h-29a5.0058,5.0058,0,0,1-5-5v-27a5.0058,5.0058,0,0,1,5-5h29a5.00581,5.00581,0,0,1,5,5v27A5.00581,5.00581,0,0,1,380.2109,394.5Z",
    transform: "translate(-185.9609 -208)",
    fill: "#f58e1a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M445.2109,394.5h-29a5.00573,5.00573,0,0,1-5-5v-61a5.00573,5.00573,0,0,1,5-5h29a5.00573,5.00573,0,0,1,5,5v61A5.00573,5.00573,0,0,1,445.2109,394.5Z",
    transform: "translate(-185.9609 -208)",
    fill: "#f58e1a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M511.2109,394.5h-29a5.00573,5.00573,0,0,1-5-5v-95a5.00573,5.00573,0,0,1,5-5h29a5.00573,5.00573,0,0,1,5,5v95A5.00573,5.00573,0,0,1,511.2109,394.5Z",
    transform: "translate(-185.9609 -208)",
    fill: "#f58e1a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M579.2109,394.5h-29a5.00573,5.00573,0,0,1-5-5v-128a5.00573,5.00573,0,0,1,5-5h29a5.00573,5.00573,0,0,1,5,5v128A5.00573,5.00573,0,0,1,579.2109,394.5Z",
    transform: "translate(-185.9609 -208)",
    fill: "#f58e1a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M849.41372,686.34423c-8.99256-7.59865-14.45479-19.60227-13.02232-31.28789s10.30472-22.42829,21.81332-24.90978,24.62761,4.38768,28.12315,15.62987c1.92376-21.67449,4.14055-44.25713,15.6641-62.715,10.43429-16.71314,28.50667-28.672,48.093-30.81147s40.20832,5.941,52.42363,21.40027,15.20618,37.93388,6.65089,55.68242c-6.30238,13.07473-17.91358,22.80511-30.07923,30.72127a194.12948,194.12948,0,0,1-132.77224,29.04621Z",
    transform: "translate(-185.9609 -208)",
    fill: "#f2f2f2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M983.14,558.63886A317.62453,317.62453,0,0,0,938.8759,602.593a318.5511,318.5511,0,0,0-49.85571,83.314c-.89773,2.1999,2.67454,3.15751,3.56229.98207a316.75881,316.75881,0,0,1,93.16977-125.638c1.84429-1.5018-.78315-4.10164-2.61223-2.61223Z",
    transform: "translate(-185.9609 -208)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M754.57076,411.05762a17.509,17.509,0,0,1-3.38574-.33936h-.00049q-.30543-.06079-.61084-.13135L505.67647,353.56738c-2.65991-.61963-4.427-2.293-4.11011-3.89306a2.65908,2.65908,0,0,1,2.03907-1.88233,7.41836,7.41836,0,0,1,3.62207-.08056l246.41772,51.46191c5.54834,1.1582,9.40015,4.56348,8.769,7.75146-.33056,1.66846-1.7998,2.96192-4.13745,3.64258A13.356,13.356,0,0,1,754.57076,411.05762Z",
    transform: "translate(-185.9609 -208)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M702.69264,403.16892a10.05575,10.05575,0,0,0,14.52487-5.17531l35.72708.745-9.8976-15.71213-32.40963,1.70134a10.11028,10.11028,0,0,0-7.94472,18.44107Z",
    transform: "translate(-185.9609 -208)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M718.2109,397.46172l-.18587-10.95079a4.52375,4.52375,0,0,1,4.06742-4.55553l64.201-6.19566,53.4904-17.53817a12.81886,12.81886,0,1,1,7.63274,24.47234l-59.2065,17.52973-65.38677,1.66091a4.50905,4.50905,0,0,1-4.42846-3.21338A4.522,4.522,0,0,1,718.2109,397.46172Z",
    transform: "translate(-185.9609 -208)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "627.258 471.782 614.998 471.781 609.166 424.493 627.26 424.494 627.258 471.782",
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M816.34559,691.66577l-39.53051-.00146v-.5a15.38605,15.38605,0,0,1,15.38647-15.38624h.001l24.1438.001Z",
    transform: "translate(-185.9609 -208)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "663.258 471.782 650.998 471.781 645.166 424.493 663.26 424.494 663.258 471.782",
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M852.34559,691.66577l-39.53051-.00146v-.5a15.38605,15.38605,0,0,1,15.38647-15.38624h.001l24.1438.001Z",
    transform: "translate(-185.9609 -208)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M857.44684,488.67394l-2.92742,173.69392a4,4,0,0,1-4.36158,3.91617l-14.34623-1.3042a4,4,0,0,1-3.62589-3.67442l-8.39886-108.34525a1,1,0,0,0-1.99629.03944l-4.19795,110.82575a4,4,0,0,1-3.99713,3.84859H798.20986a4,4,0,0,1-3.99255-3.756l-10.77047-176.244,64-16Z",
    transform: "translate(-185.9609 -208)",
    fill: "#2f2e41"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 625.06469,
    cy: 93.01646,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M781.25544,493.84093a4.46917,4.46917,0,0,1-1.3645-3.165L778.2342,372.23351a28.50083,28.50083,0,0,1,19.282-27.44141c2.301-10.43945,14.54785-11.74707,21.68726-11.59082a11.08483,11.08483,0,0,1,8.97753,4.92286l5.11792,7.67675,11.28028,6.61231a28.528,28.528,0,0,1,13.47021,30.8164l-1.73657,7.89942a181.54018,181.54018,0,0,0,1.69775,84.66015l3.49463,13.32422a4.49944,4.49944,0,0,1-4.698,5.62793l-4.05859-.3125a4.49385,4.49385,0,0,1-4.13257-4.03808l-.67163-6.7168a.50005.50005,0,0,0-.99512,0l-.65014,6.50293a4.49951,4.49951,0,0,1-4.40845,4.05176l-57.43091.88379c-.02392,0-.0476.001-.07153.001A4.47131,4.47131,0,0,1,781.25544,493.84093Z",
    transform: "translate(-185.9609 -208)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M812.94684,315.17394c.10071,3.472,2.51116,5.48065,5.47053,7.29924s6.41876,2.60712,9.808,3.36775a2.99861,2.99861,0,0,0,4.40515-2.62457l3.1084-11.82324a74.84063,74.84063,0,0,0,2.39306-11.537c.74862-7.50914-1.031-15.58706-6.27222-21.01634s-14.33084-7.358-20.6116-3.17478c-7.45361-9.51978-41.52343,11.513-33.11914,18.13281,1.49512,1.17768,3.78064-.31249,5.67841-.45693s4.02454.18937,5.23,1.66219c1.575,1.9242.889,4.79052,1.538,7.1909a6.71431,6.71431,0,0,0,8.48369,4.34833,23.08806,23.08806,0,0,0,4.39987-2.8286c1.45566-.96958,3.29506-1.686,4.93368-1.0745,2.15991.80607,2.92723,3.45041,3.12242,5.74755A53.23512,53.23512,0,0,0,812.94684,315.17394Z",
    transform: "translate(-185.9609 -208)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M994.892,692h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-185.9609 -208)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "621.25 173 617.25 222 596.25 273 627.25 223 621.25 173",
    opacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M777.30034,499.99214a10.05576,10.05576,0,0,0,.31761-15.41606l13.37856-33.136-18.20228,3.67571-9.9139,30.903a10.11028,10.11028,0,0,0,14.42,13.97337Z",
    transform: "translate(-185.9609 -208)",
    fill: "#ffb8b8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M776.32622,485.378l-10.30362-3.71344a4.52376,4.52376,0,0,1-2.81506-5.41962l16.99724-62.21933,2.59146-56.2325a12.81885,12.81885,0,1,1,25.588,1.55127l-4.62838,61.57336L782.09828,482.636a4.509,4.509,0,0,1-4.57608,2.99941A4.5218,4.5218,0,0,1,776.32622,485.378Z",
    transform: "translate(-185.9609 -208)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M620.2109,394.5h-296a1,1,0,0,1,0-2h296a1,1,0,0,1,0,2Z",
    transform: "translate(-185.9609 -208)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDevNoBg);
export default __webpack_public_path__ + "static/media/appDevNoBg.4f440202d5888587094289476924403a.svg";
export { ForwardRef as ReactComponent };